module.exports = __webpack_public_path__ + "img/look2.218a568c.png";